import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import './ProjectInvitationCard.scss';
function ProjectInvitationCard(_ref) {
  var consultantName = _ref.consultantName,
    userUrl = _ref.userUrl,
    starRating = _ref.starRating,
    hourlyRate = _ref.hourlyRate,
    status = _ref.status,
    statusString = _ref.statusString,
    roles = _ref.roles,
    bio = _ref.bio;
  return /*#__PURE__*/React.createElement("a", {
    href: userUrl,
    target: "_blank",
    className: "project-invitation",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "style-guide project-invitation-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name-review-status g-row g-row--between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "fs-hide"
  }, consultantName), starRating && /*#__PURE__*/React.createElement("div", {
    className: "rating-avg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always"
  }, /*#__PURE__*/React.createElement(StarRatings, {
    rating: starRating || 0,
    starRatedColor: "#EDA318",
    starHoverColor: "#EDA318",
    starDimension: "20px",
    starSpacing: "0.5px",
    numberOfStars: 5,
    name: "rating_avg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "body-text-2 medium-weight ms-2"
  }, starRating && starRating.toFixed(1) || 0)))), /*#__PURE__*/React.createElement("div", null, hourlyRate && /*#__PURE__*/React.createElement("span", {
    className: "invitation-hourly-rate mr-8"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-text-2 medium-weight"
  }, hourlyRate), /*#__PURE__*/React.createElement("span", {
    className: "body-text-2 normal-weight"
  }, "/hour")), /*#__PURE__*/React.createElement("span", {
    className: "invitation-status body-text-3 ".concat(status === 'rejected' && 'rejected')
  }, statusString))), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight"
  }, roles), /*#__PURE__*/React.createElement("div", {
    className: "bio-row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 normal-weight"
  }, bio))));
}
ProjectInvitationCard.propTypes = {
  consultantName: PropTypes.string.isRequired,
  userUrl: PropTypes.string.isRequired,
  starRating: PropTypes.number.isRequired,
  hourlyRate: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  statusString: PropTypes.string.isRequired,
  roles: PropTypes.string.isRequired,
  bio: PropTypes.string.isRequired
};
export default ProjectInvitationCard;